/* eslint-disable */
// Classes
import { Range } from '../../classes/filter.classes';

export class DateRegistered {
  selection?: 'Any' | 'Select Recency' | 'Specific Date Range';
  value?: any;
  constructor(
    selection?: 'Any' | 'Select Recency' | 'Specific Date Range',
    value?: any
  ) {
    this.selection = selection || 'Select Recency';
    this.value = value || {
      value: 'Within_Last_7_Days',
      label: 'Within Last 7 Days',
    };
  }
}

export class RelativeEngagement {
  high?: boolean;
  medium?: boolean;
  low?: boolean;

  constructor(high?: boolean, medium?: boolean, low?: boolean) {
    this.high = high || false;
    this.medium = medium || false;
    this.low = low || false;
  }
}

export class TotalTimeSpent {
  selection?: 'Any' | 'VT' | 'IWC' | 'VT or IWC' | 'VT and IWC';
  value?: {
    vt?: Range;
    iwc?: Range;
  };

  constructor(
    selection?: 'Any' | 'VT' | 'IWC' | 'VT or IWC' | 'VT and IWC',
    value?: {
      vt?: Range;
      iwc?: Range;
    }
  ) {
    (this.selection = selection || 'Any'),
      (this.value = (value && value.vt && value.iwc && value) ||
        (value &&
          value.vt &&
          !value.iwc && {
          ...value,
          iwc: new Range(1, 15),
        }) ||
        (value &&
          !value.vt &&
          value.iwc && {
          ...value,
          vt: new Range(1, 15),
        }) || {
        vt: new Range(1, 15),
        iwc: new Range(1, 15),
      });
  }
}

export class Activity {
  selection?: 'Any' | 'Active' | 'Inactive';
  value?: any;
  constructor(selection?: 'Any' | 'Active' | 'Inactive', value?: any) {
    this.selection = selection || 'Any';
    this.value = value || undefined;
  }
}

export class EngagementReducerState {
  dateRegistered?: DateRegistered;
  relativeEngagement?: RelativeEngagement;
  totalTimeSpent?: TotalTimeSpent;
  scheduledVisit?: 'Any' | 'Yes' | 'No';
  applied?: 'Any' | 'Yes' | 'No';
  activityWithInstitution?: Activity;
  activityWithEAB?: Activity;

  constructor(
    dateRegistered?: DateRegistered,
    relativeEngagement?: RelativeEngagement,
    totalTimeSpent?: TotalTimeSpent,
    scheduledVisit?: 'Any' | 'Yes' | 'No',
    applied?: 'Any' | 'Yes' | 'No',
    activityWithInstitution?: Activity,
    activityWithEAB?: Activity
  ) {
    this.dateRegistered = dateRegistered || new DateRegistered();
    this.relativeEngagement = relativeEngagement || new RelativeEngagement();
    this.totalTimeSpent = totalTimeSpent || new TotalTimeSpent();
    this.scheduledVisit = scheduledVisit || 'Any';
    this.applied = applied || 'Any';
    this.activityWithInstitution = activityWithInstitution || new Activity();
    this.activityWithEAB = activityWithEAB || new Activity();
  }
}
